import { RequestState } from '../../../../types/request-state.model';
import { DashboardMetricData, PotentialCommission } from '../../../../types/dashboard.model';
import { BrokerLeaderboard } from '../../../../types/broker-leaderboard.model';
import { Listing } from '../../../../types';

const PREFIX = '[Dashboard]';

export const GET_DASHBOARD_DATA = `${PREFIX} GET_DASHBOARD_DATA`;
export const GET_DASHBOARD_DATA_SUCCESS = `${PREFIX} GET_DASHBOARD_DATA_SUCCESS`;
export const GET_DASHBOARD_DATA_FAIL = `${PREFIX} GET_DASHBOARD_DATA_FAIL`;

export const GET_BROKER_LEADERBOARD_DATA = `${PREFIX} GET_BROKER_LEADERBOARD_DATA`;
export const GET_BROKER_LEADERBOARD_DATA_SUCCESS = `${PREFIX} GET_BROKER_LEADERBOARD_DATA_SUCCESS`;
export const GET_BROKER_LEADERBOARD_DATA_FAIL = `${PREFIX} GET_BROKER_LEADERBOARD_DATA_FAIL`;

export interface DashboardState {
  getDashboardDataState?: RequestState;

  metricData?: DashboardMetricData;

  rentalPotentialCommission?: PotentialCommission;
  salePotentialCommission?: PotentialCommission;

  brokerLeaderboard?: BrokerLeaderboard[];

  topListingsByInquiries?: Listing[];
  topListingsByViews?: Listing[];
}

export interface DashboardAction {
  type: string,
  payload?: DashboardState
}